import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2ab9a6d8&scoped=true&"
import script from "./App.ts?vue&type=script&lang=ts&"
export * from "./App.ts?vue&type=script&lang=ts&"
import style0 from "./app.scss?vue&type=style&index=0&id=2ab9a6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9a6d8",
  null
  
)

export default component.exports